import { useNavigate, useParams } from "react-router-dom";
import { useAuthState } from "react-firebase-hooks/auth";
import { getAuth } from "firebase/auth";
import Archive from "../components/projects/archive";
import { useMemo } from "react";
import { doc, getFirestore } from "firebase/firestore";
import { ProjectRole, projectDocumentSchema } from "../types/firestore";
import { getFirestoreZodConverter } from "../modules/firestoreZodConverter";
import { useDocumentData } from "react-firebase-hooks/firestore";
import Card from "react-bootstrap/Card";
import Member from "../components/projects/member";
import AddMember from "../components/projects/addMember";
import Leave from "../components/projects/leave";
import LoadingAlert from "../components/common/loadingAlert";

const firestore = getFirestore();
const auth = getAuth();

export default function Project() {
	const navigate = useNavigate();

	const [user, userLoading] = useAuthState(auth);

	if (!user && !userLoading) {
		navigate("/account");
	}

	const { projectId } = useParams();
	if (!projectId) throw "Project page requires a projectId parameter.";

	const projectDocumentRef = useMemo(
		() =>
			doc(firestore, "Projects", projectId).withConverter(
				getFirestoreZodConverter(projectDocumentSchema),
			),
		[projectId],
	);

	const [projectDocument, , projectDocumentError] = useDocumentData(projectDocumentRef);

	if (!user || !projectDocument) {
		return <LoadingAlert error={projectDocumentError} />;
	}

	const role = projectDocument.Members[user.uid];

	const isOwner = role === ProjectRole.Owner;
	const isAdmin = isOwner || role === ProjectRole.Admin;

	const memberEntries = Object.entries(projectDocument.Members);

	return (
		<div>
			<Card className="mb-2">
				<Card.Header className="mb-2 fw-bold">{projectDocument.Name}</Card.Header>

				<Card.Body>
					<div className="mb-2">Mitglieder</div>

					<div className="mb-2">
						{memberEntries
							.sort(([memberA], [memberB]) => (memberA > memberB ? -1 : 1))
							.map(([memberId, role]) => (
								<Member
									projectId={projectId}
									memberId={memberId}
									memberRole={role}
									isCurrentUserAdmin={isAdmin}
									key={memberId}
								/>
							))}
					</div>

					{isAdmin && <AddMember projectId={projectId} />}
				</Card.Body>
			</Card>
			{isOwner ? (
				<Archive projectId={projectId} projectOwner={user.uid} />
			) : (
				<Leave projectId={projectId} />
			)}
		</div>
	);
}
